<template>
	<div>
		<v-navigation-drawer fixed v-model="navStateFilter" :clipped="$vuetify.breakpoint.lgAndUp" app right class="mt-0" style="top: 0; height: 100%; max-height: 100%" width="350">
			<v-card-title>
				{{ this.$vuetify.lang.t('$vuetify.front.filters') }}
				<v-spacer></v-spacer>
			</v-card-title>
			<v-list dense>
				<v-list-item>
					<v-text-field hide-details="auto" @keyup="searchit" v-model="searchfield" append-icon="search" label="Search"></v-text-field>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.customers.list') }} {{ listing.name }} </v-toolbar-title>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!--<v-btn text :href="linkdownload+'?search='+searchfield+'&categories='+settings.filters.categories+'&selected='+selected" exact >
                                    <v-icon>mdi-arrow-collapse-down</v-icon>
                                </v-btn>-->
								<!--<v-btn text
                                       :href="this.getUrl+'items/download?token='+this.getToken+'&search='+this.searchfield+'&filters='+this.settings.filters+'&selected='+this.selected"
                                       exact>
                                    <v-icon>mdi-arrow-collapse-down</v-icon>
                                </v-btn>-->
								<!--<v-btn text @click="toggleDrawerSort">
                                    <v-icon>mdi-sort</v-icon>
                                </v-btn>-->
								<!-- <v-divider vertical></v-divider>-->
								<v-btn
									text
									to="/npm run dev
                                       setting/listing"
									exact
								>
									<v-icon>mdi-arrow-collapse-left</v-icon>
								</v-btn>
								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>

								<!-- <v-divider vertical></v-divider>-->
								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text>
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<!--<v-list-item @click="getCategoryMagento" v-if="magento">
                                            <v-list-item-icon>
                                                <v-icon>mdi-plus</v-icon>
                                            </v-list-item-icon>

                                            <v-list-item-content>
                                                <v-list-item-title>Importa da Magento</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>-->
										<v-list-item @click="createItem">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Aggiungi cliente</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
								<!--<v-divider vertical></v-divider>
-->
							</v-toolbar-items>
						</v-toolbar>

						<v-card v-if="selected.length > 0" elevation="0" outlined>
							<v-tabs dark background-color="primary " show-arrows>
								<v-tabs-slider color="primary "></v-tabs-slider>

								<v-tab>
									{{ selected.length }}
									<span v-if="selected.length == 1" style="margin-left: 1rem"> selezionato </span>
									<span v-else style="margin-left: 1rem"> selezionati </span>
								</v-tab>

								<v-tab @click="anagraficaItem" v-if="selected.length == 1"> gestione prodotti </v-tab>
							</v-tabs>
						</v-card>

						<v-data-table
							v-model="selectedall"
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							@input="toggle"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							show-select
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<!--:hide-default-header="isMobile"
                            :class="{mobile: isMobile}"-->

							<!-- <template slot="headers" slot-scope="props">
                                 <tr>
                                     <th>
                                         <v-checkbox
                                                 primary
                                                 hide-details
                                                 @click.native="toggleAll"
                                                 :input-value="props.all"
                                                 :indeterminate="props.indeterminate"
                                         ></v-checkbox>
                                     </th>
                                     <th v-for="header in props.headers" :key="header.text"
                                         :class="['column sortable', settings.pagination.descending ? 'desc' : 'asc', header.value === settings.pagination.pagination.sortBy ? 'active' : '']"
                                         @click="changeSort(header.value)"
                                     >
                                         <v-icon>arrow_upward</v-icon>
                                         {{ header.text }} f
                                     </th>
                                 </tr>
                             </template>-->
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="listing-user-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length + 1" class="px-3 py-1">
											<key-value-card :title="nomeCard(item)" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-checkbox class="mt-0 pt-0 mr-2" v-model="selected" :value="item._id" color="primary" hide-details></v-checkbox>
												</template>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="(item, index) in items" :key="`${item._id}${_.random(1, 10000)}`">
										<!-- v-bind:class="toggleClass(1)"-->
										<!--<td >  <v-checkbox color="blue" v-model="selected" :value="item" hide-details style="margin-top: 0px;padding-top: 0px;" ></v-checkbox></td>-->

										<td>
											<v-checkbox class="mt-0" v-model="selected" :value="item._id" color="primary" hide-details></v-checkbox>
										</td>

										<td>
											{{ item.created_at | moment('DD/MM/YYYY') }}
										</td>
										<td>
											{{ item.buyer.name }}
											<!---->
										</td>
										<td>
											{{ item.buyer.lastname }}
										</td>
										<td>
											{{ item.buyer.email }}
										</td>
										<td>{{ item.InvoiceAddress.Company }}</td>

										<td>{{ item.InvoiceAddress.Vat }}</td>

										<!--td>{{ item.id }}</td-->
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
					<!--<v-btn
                            fab
                            bottom
                            right
                            color="secondary"
                            dark
                            fixed
                            @click.prevent="openNew()"
                    >

                        <v-icon>add</v-icon>
                    </v-btn>-->
				</v-layout>
			</v-container>
		</v-main>
		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<FormDuplicate v-if="operation == 'FormDuplicate'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormDuplicate>
			<FormEdit v-if="operation == 'FormEdit'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormEdit>
			<FormCreate v-if="operation == 'FormCreate'" :key="componentKey" @event="getDataFromApi"></FormCreate>
			<FormFile v-if="operation == 'FormFile'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormFile>
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando la categoria non potrai più ripristinarla. I prodotti associati resteranno senza categoria </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { openWithReturn } from '@/components/core/pageReturn';
import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';

Vue.use(VuetifyDraggableTreeview);
import VueLodash from 'vue-lodash';
import lodash from 'lodash';

import KeyValueCard from '@/components/core/KeyValueCard.vue';

const FormCreate = () => import('@/components/customers/Create.vue');
const FormEdit = () => import('@/components/customers/Edit.vue');

export default {
	name: 'Users',
	data() {
		return {
			componentKey: 0,
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',
			items: [],
			setinterval: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					listing: this.$route.params.id,
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},
			listSize: [15, 25, 50, 100],
			searchfield: '',
			selected: [],
			selectedall: [],
			total: 0,
			headers: [
				{ text: 'Created', value: 'created_at', sortable: true },
				{ text: 'Name', value: 'buyer.name', sortable: true },
				{ text: 'Lastname', value: 'buyer.lastname', sortable: true },
				{ text: 'Email', value: 'buyer.email', sortable: true },
				{ text: 'Company', value: 'InvoiceAddress.Company', sortable: true },
				{ text: 'Vat', value: 'InvoiceAddress.Vat' },
			],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			dialogconfirm: false,
			dialogconfirmImport: false,
			isActive: true,
			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			listCategories: [],
			treeCategories: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',
			page: 1,
			isMobile: false,
			operation: '',
			magento: false,
			shopify: false,
			langDefault: '',
			brands: [],
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			selectListings: [],
			listing: {},
			urlback: `/listing/${this.$route.params.id}/users`,
		};
	},

	filters: {
		fixed: function (value) {
			if (!value) return '';
			return (value = value.toFixed(2));
		},
	},
	async mounted() {
		var listing = await this.getDetailListing(this.$route.params.id);
		this.listing = listing.data.data;
		//this.settings.filters.listing = this.$route.params.id
		console.log(this.listing);
	},
	created() {
		this.setDialog(false);
		this.setExistFilter(true);

		this.fetchSetting().then(data => {
			this.langDefault = _.find(data.languages, { default: true }).lang;
		});
		this.getListings().then(res => {
			_.forEach(res.data, el => {
				this.selectListings = [{ _id: el._id, name: el.name }, ...this.selectListings];
			});
		});
	},
	watch: {
		selectedLength(val, oldVal) {
			if (val > 0) {
				this.selectedall = [-1];
			}
		},
		settings: {
			handler: function (val) {
				if (_.isUndefined(this.settings.options.sortBy[0]) && this.settings.options.sortBy[0] != '') {
					var outcome = this.getSortDesc;
					outcome = !outcome;
					this.settings.options.sortBy = [];
					this.settings.options.sortDesc = [];
					this.settings.options.sortBy.push(this.getSortBy);
					this.settings.options.sortDesc.push(outcome);
				}
				if (val.options.page == this.page) {
					this.settings.options.page = 1;
				}
				this.page = val.options.page;
				this.getDataFromApi();
			},
			deep: true,
		},
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		FormCreate,
		FormEdit,
		KeyValueCard,

		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		selectedLength() {
			return this.selected.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'customers/getIndex',
			getItems: 'customers/getItems',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'customers/getSortBy',
			getSortDesc: 'customers/getSortDesc',
			getSettings: 'settings/getSetting',
		}),

		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function (old, newvalue) {
				return this.clippedOrder;
			},
			set: function (newvalue) {
				return this.clippedOrder;
			},
		},
	},

	methods: {
		// titolo della card: nome e cognome del cliente
		nomeCard(item) {
			const buyer = item.buyer || {};
			return [buyer.name, buyer.lastname].filter(Boolean).join(' ') || '-';
		},
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			const buyer = item.buyer || {};
			const invoice = item.InvoiceAddress || {};
			return [
				{ label: 'Created', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
				{ label: 'Email', value: buyer.email },
				{ label: 'Company', value: invoice.Company, strong: true },
				{ label: 'Vat', value: invoice.Vat },
			];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setItems: 'customers/setItems',
			setItem: 'customers/setItem',
			setIndex: 'customers/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'customers/asyncFetchData',
			deleteItems: 'customers/deleteItems',
			destroyData: 'customers/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			getListings: 'listings/getListings',
			getDetailListing: 'listings/getDetailListing',
			//'resetMessages' : 'settings/resetMessages'
		}),

		toggle(event) {
			if (_.size(this.selectedall) == 0) {
				this.selected = [];
			} else {
				//console.log(this.selected[0])
				if (event[0] != -1) {
					this.selected = [];
					_.forEach(this.getItems, cat => {
						this.selected.push(cat._id);
					});
				}
			}
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},
		async anagraficaItem() {
			this.componentKey += 1;
			this.setClearError({});
			//await this.resetMessages();
			//console.log(this.getOrders.indexOf(item));
			//console.log(item)

			this.operation = 'FormItem';
			var item = _.find(this.getItems, search => {
				return search._id == this.selected[0];
			});

			this.setIndex(this.getItems.indexOf(item));
			this.$router.push(`/listings/${this.$route.params.id}/users/${item._id}`);
			/*this.setListing(item);
                this.setMessages();
                this.setDialog(true);
                this.setSnackbar(false);*/
		},
		async editItem() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'FormEdit';
			var item = _.find(this.getItems, search => {
				return search._id == this.selected[0];
			});
			// la scheda cliente e' una pagina: ci si va e, salvando o annullando, si torna qui
			if (!item) return;
			this.setMessages();
			openWithReturn(this, { path: `/customers/${item._id}` }, { label: 'Torna agli utenti del listino' });
		},
		async createItem() {
			this.componentKey += 1;
			this.setClearError({});
			//await this.resetMessages();
			//console.log(this.getOrders.indexOf(item));
			//console.log(item)
			this.operation = 'FormCreate';

			// la scheda cliente e' una pagina: ci si va e, salvando o annullando, si torna qui
			this.setMessages();
			openWithReturn(this, { path: '/customers/new' }, { label: 'Torna agli utenti del listino' });
			/*Vue.component(
                    'FormEdit',
                    // A dynamic import returns a Promise.
                    () => import('@/components/orders/Edit.vue')
                )*/
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 2) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),
		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.operation = '';
		},
		convertListing(_id) {
			if (_id != '') {
				var check = _.find(this.selectListings, { _id: _id });
				if (check) {
					return check.name;
				} else {
					return '';
				}
			}
		},
		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				const { sortBy, sortDesc, page, itemsPerPage } = this.settings.options;

				let items = this.fetchItems(this.settings);
				items
					.then(result => {
						this.total = result.total;
						//this.items = result.data.data
						this.setPreload(false);
						this.selected = [];
						this.selectedall = [];
					})
					.then(() => {
						/*this.getFetchTreeCategory().then(() => {

                            var find =  _.orderBy(this.getCategoriesTree, 'parent.id', 'asc');

                            if(_.size(find)>0) {
                                if (_.size(find) > 1) {
                                    this.firstLevel = _.filter(this.getCategoriesTree, filter => {
                                        return filter.parent.id == find[0].parent.id
                                    })
                                    // console.log(this.firstLevel)
                                }

                                this.getNestedCategory(find[0].parent.id).then(() => {

                                    this.items = this.getCategoriesChildrean
                                })
                            }


                        })*/
					});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		/*checkpresenza(item) {
                return this.selected.includes(item)
            },
*/
		closeSnackbar() {
			this.setSnackbar(false);
		},

		deleteItem(item) {
			this.dialogconfirm = true;
			this.form = item;
		},

		confirmDelete() {
			this.dialogconfirm = false;
			let url = 'customers/delete';

			this.messages = [];
			var paypload = [];
			_.forEach(this.selected, cat => {
				var index = _.find(this.getItems, { _id: cat });

				if (index) {
					paypload.push(index);
				}
			});

			this.deleteItems(paypload)
				.then(data => {
					this.setPreload(false);
					this.getDataFromApi().then(res => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
	beforeDestroy() {
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.listing-user-cards,
.listing-user-cards tr {
	display: block;
	width: 100%;
}
.listing-user-cards tr,
.listing-user-cards tr:hover {
	background: transparent !important;
}
.listing-user-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.listing-user-cards tr:first-child td {
	padding-top: 12px !important;
}
.listing-user-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.listing-user-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
